import { JobWidget } from "./type.ts";

export const InterviewType = {
  Phone: "phone",
  Web: "web",
  Coding: "coding",
} as const;

export const CreditSummary = {};

export const widgetsData: JobWidget[] = [
  {
    title: "Invite Candidates",
    disabled: false,
    interviewTypes: [InterviewType.Web, InterviewType.Phone],
    path: "invite-candidates",
    icon: "/widgets/invitation.png",
  },
  {
    title: "Interview Settings",
    disabled: false,
    interviewTypes: [InterviewType.Web],
    path: "settings",
    icon: "/widgets/settings.png",
  },
  {
    title: "Configure Score",
    disabled: false,
    interviewTypes: [InterviewType.Web, InterviewType.Phone],
    path: "edit",
    icon: "/widgets/edit.png",
  },
  {
    title: "Integrate with Calendly",
    disabled: false,
    interviewTypes: [InterviewType.Web],
    path: "calendly",
    icon: "/widgets/calendly.png",
  },
  {
    title: "Interview Designer",
    disabled: false,
    interviewTypes: [InterviewType.Web, InterviewType.Phone],
    path: "preview",
    icon: "/widgets/config.png",
    spanClass: "inline-block p-px",
    imgClass: "",
  },
];
